/** SHA-256 hex (WebCrypto). Apple 로그인 nonce: Apple에는 해시를 보내고 서버에는 원문을 보낸다(auth-session 3.8). */
export async function sha256Hex(s: string): Promise<string> {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(s));
  return Array.from(new Uint8Array(digest), (b) => b.toString(16).padStart(2, "0")).join("");
}
